import React from "react";
import {
  Card,
  CardContent,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  badge: {
    display: "inline-block",
    minWidth: 28,
    borderRadius: 14,
    padding: "4px 8px",
    fontSize: 12,
    textAlign: "center",
    color: "#fff",
    marginRight: 10,
  },
  progress: {
    height: 6,
    borderRadius: 4,
    backgroundColor: "#f0f0f0",
  },
  tableCell: {
    borderBottom: "1px solid #efefef",
  },
  sourceCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 10,
  },
}));

const BudgetBySourceTable = ({ rows = [] }) => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Typography className={classes.title}>原資別 予算詳細</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>原資</TableCell>
              <TableCell className={classes.tableCell} align="right">予算</TableCell>
              <TableCell className={classes.tableCell} align="right">消化</TableCell>
              <TableCell className={classes.tableCell} align="right">残</TableCell>
              <TableCell className={classes.tableCell}>進捗</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row) => (
                <TableRow key={row.code}>
                  <TableCell className={classes.tableCell}>
                    <div className={classes.sourceCell}>
                      <span className={classes.badge} style={{ backgroundColor: row.color }}>
                        {row.code}
                      </span>
                      <span>{row.name}</span>
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableCell} align="right">{row.budget}</TableCell>
                  <TableCell className={classes.tableCell} align="right">{row.used}</TableCell>
                  <TableCell className={classes.tableCell} align="right">{row.remaining}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <LinearProgress
                      className={classes.progress}
                      variant="determinate"
                      value={row.progress}
                      style={{
                        backgroundColor: "#f3f3f3",
                      }}
                    />
                    <Typography variant="caption" display="block" align="right">
                      {row.progressLabel || `${Number(row.progress || 0).toFixed(1)}%`}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell className={classes.tableCell} colSpan={5} align="center">
                  データなし
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default BudgetBySourceTable;
